export default {
  translation: {
    common: {
      emailOrUsername: 'Eメールまたはユーザー名',
      invalidUsernameOrPassword: 'ユーザーネームまたはパスワードが違います',
      logInToBoards: 'にログインする',
      noInternetConnection: 'インターネットに接続されていません。',
      pageNotFound_title: 'ページが見つかりません。',
      password: 'パスワード',
      serverConnectionFailed: 'サーバーの接続に失敗',
      unknownError: '不明なエラーです。後でもう一度試してください。',
    },

    action: {
      logIn: 'ログイン',
    },
  },
};
